import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavigationBar } from "../components/components";
import "../styles/Error.css"; // Import CSS file for styling

const childVariants = {
  initial: {
    opacity: 0,
    y: "50px",
  },
  final: {
    opacity: 1,
    y: "0px",
    transition: {
      duration: 0.5,
    },
  },
};

const DownloadRedirect = () => {
  const [periods, setPeriods] = useState(".");

  useEffect(() => {
    const interval = setInterval(() => {
      setPeriods((prevPeriods) => {
        switch (prevPeriods) {
          case "":
            return ".";
          case ".":
            return "..";
          case "..":
            return "...";
          case "...":
            return "";
          default:
            return "";
        }
      });
    }, 1000); // Change the interval duration as needed

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.vibeinc.onedate";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.href =
        "https://apps.apple.com/sg/app/one-date-your-last-dating-app/id6503325960";
    } else {
      window.location.href = "/";
    }
  }, []);

  return (
    <motion.div variants={childVariants} initial="initial" animate="final">
      <NavigationBar color={false} />

      <div className="error">
        <h1 style={{ fontSize: "6vw" }}>
          Redirecting
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="motion-span"
          >
            {periods || "\u00A0"}
          </motion.span>
        </h1>
      </div>
    </motion.div>
  );
};

export default DownloadRedirect;
